import React from 'react';
import { Tooltip } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface CountBadgeProps {
  count: number;
  label?: string;
  tooltipText?: string;
  variant?: 'neutral' | 'success' | 'amber';
  className?: string;
}

/**
 * Compact count pill with a hover tooltip.
 */
export const CountBadge: React.FC<CountBadgeProps> = ({
  count,
  label,
  tooltipText,
  variant = 'neutral',
  className,
}) => {
  if (count <= 0) return null;
  const tip = tooltipText || `${count} ${label || 'account'}${count > 1 ? 's' : ''} connected`;

  const variantStyles = {
    neutral: 'bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 border-slate-200/80 dark:border-slate-700',
    success: 'bg-emerald-50 dark:bg-emerald-950/40 text-emerald-700 dark:text-emerald-300 border-emerald-200/80 dark:border-emerald-800/60',
    amber: 'bg-amber-50 dark:bg-amber-950/40 text-amber-700 dark:text-amber-300 border-amber-200/80 dark:border-amber-800/60',
  };

  return (
    <Tooltip content={tip} placement="top">
      <span
        className={cn(
          'inline-flex items-center justify-center rounded-md px-1.5 py-0.2 text-[10px] font-bold tracking-tight border shadow-2xs cursor-pointer hover:opacity-85 transition-opacity',
          variantStyles[variant],
          className
        )}
      >
        {count}
      </span>
    </Tooltip>
  );
};

export default CountBadge;
